<ion-footer>
  <ion-progress-bar *ngIf="leftDate" [color]="'danger'" [value]="progress"></ion-progress-bar>
  <ion-toolbar>
    <ion-grid class="footer">
      <ion-row>
        <ion-col *ngIf="leftDate" sizeXs="12" sizeLg="6">
          <ion-item lines="none">
            <ion-spinner [color]="'danger'" slot="start"></ion-spinner>
            <ion-label>
              <ion-text [color]="'danger'">
                <h1 class="ion-text-center" style="font-size: 15px">
                  Tienes <strong>{{ leftDate | date : 'mm:ss' }}</strong> minutos para pagar tu juego
                </h1>
              </ion-text>
            </ion-label>
          </ion-item>
        </ion-col>
        <ion-tab-button *ngIf="showClear" (click)="clear()">
          <ion-icon src="/assets/icons/clear.svg"></ion-icon>
          <ion-label>Limpiar</ion-label>
        </ion-tab-button>
        <ion-col *ngIf="showBalance" sizeXs="4" sizeLg="2" [offsetLg]="leftDate ? 0 : 4">
          <ion-text color="primary">
            <h3 class="ion-text-center">{{ balance | currency }}</h3>
            <p class="ion-text-center">Saldo</p>
          </ion-text>
        </ion-col>
        <ion-col *ngIf="showSelect">
          <ion-text color="primary">
            <p class="ion-text-center">{{ size }}</p>
          </ion-text>
          <ion-select
            #selectSize
            (ionChange)="onChange(selectSize.value)"
            cancel-text="Cerrar"
            interface="action-sheet"
            [value]="size"
          >
            <ion-select-option *ngFor="let item of selectData" [value]="item.value">{{ item.text }}</ion-select-option>
          </ion-select>
        </ion-col>
        <ion-col sizeXs="4" sizeLg="2">
          <ion-text [color]="amount > balance ? 'medium' : 'primary'">
            <h3 class="ion-text-center">{{ amount | currency }}</h3>
            <p class="ion-text-center">Importe</p>
          </ion-text>
        </ion-col>
        <ion-col *ngIf="showButton" sizeXs="4" sizeLg="2">
          <ion-button
            expand="block"
            fill="solid"
            (click)="onClick()"
            [disabled]="(!isProgol && amount === 0) || isBlock"
            shape="round"
          >
            <ion-icon slot="start" name="send-outline"></ion-icon>
            {{ buttonText }}
          </ion-button>
        </ion-col>
      </ion-row>
    </ion-grid>
  </ion-toolbar>
</ion-footer>
